import { useMediaQuery } from '@mui/material';
import { BackButton } from 'atoms/BackButton';
import { MediaQueryEnum } from 'commons/utils';
import { useTranslationWithLang } from 'hooks/useTranslationWithLang';
import { AppFooter } from 'templates/AppFooter';
import { UnauthHeader } from 'templates/UnauthHeader';

export const NotFound = () => {
  const { t: tCommons } = useTranslationWithLang('commons');
  const isSp = useMediaQuery(MediaQueryEnum.sp);
  if (isSp) {
    return (
      <>
        <div
          className="flex flex-col items-center justify-center h-screen"
          style={{ background: 'var(--c-background)' }}
        >
          <UnauthHeader />
          <h1 className="text-3xl font-bold text-[--c-text]">404</h1>
          <p className="text-sm text-[--c-text] text-center">{tCommons('TU000_068')}</p>
          <p className="text-sm text-[--c-text] text-center">{tCommons('TU000_069')}</p>
          <BackButton className="w-[9rem]" />
          <AppFooter />
        </div>
      </>
    );
  }

  return (
    <>
      <div
        className="flex flex-col items-center justify-center h-screen"
        style={{ background: 'var(--c-background)' }}
      >
        <UnauthHeader />
        <h1 className="text-5xl font-bold text-[--c-text]">404</h1>
        <p className="text-xl text-[--c-text]">{tCommons('TU000_068')}</p>
        <p className="text-xl text-[--c-text]">{tCommons('TU000_069')}</p>
        <BackButton className="w-[9rem]" />
        <AppFooter />
      </div>
    </>
  );
};
